"use strict";

var wl = 'at_wishlist';

function hdListeLesen() {
  try { return JSON.parse(localStorage.getItem(wl)) || []; }
  catch (e) { return []; }
}

class WishlistItems extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.getWlProducts(hdListeLesen());
  }
  getWlProducts(p){
      var query = "",
        ajaxURL = "";

    if(p && p.length > 0) {
      query = p.join("%20OR%20id:");
      ajaxURL = `?q=id:${query}`;
    }

    fetch(`${this.dataset.url}${ajaxURL}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const wlProducts = html.querySelector("#collection-products");
        const wlDiv = document.querySelector("#wishlist");
        if (wlProducts && wlProducts.innerHTML.trim().length) {
          wlDiv.innerHTML = wlProducts.innerHTML;
          document.querySelector(".wlnull").classList.add('hide');
          this.removeItem();
        }
      })
      .finally(() => {
        checkWishlist();
        initializeScrollAnimationTrigger();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  removeItem(){
    var products = this.querySelectorAll(".grid-content");
    products.forEach((box) => {
        var quelle = box.querySelector(".addwishlist");
        var id = quelle ? quelle.dataset.id : "";
        if (!id) { return; }

        box.insertAdjacentHTML("beforeend",
          `<button type="button" class="grid-button pr remove-item hd-merk-weg" data-id="${id}" aria-label="Aus der Merkliste entfernen"><span class="txt"><svg class="at-icon wishicon added"><use xlink:href="#icon-wishlist-add"></use></svg></span><span class="wish-txt hide" aria-hidden="true"></span><svg class="at-icon at-spin"><use xlink:href="#icon-loading"></use></svg></button>`);
    });

    var buttons = this.querySelectorAll(".remove-item");
    buttons.forEach((btn) => {
        var wraper = btn.closest('.gitem');
      btn.addEventListener("click", function(){
        const id = this.dataset.id;
        var liste = hdListeLesen();
        const index = liste.indexOf(id);
        if (index !== -1) {
          liste.splice(index, 1);
          localStorage.setItem(wl, JSON.stringify(liste));
        }
        if (wraper) { wraper.remove(); }
        checkWishlist();

        var rest = document.querySelectorAll("#wishlist .grid-content").length;
        var leer = document.querySelector(".wlnull");
        if (rest === 0 && leer) { leer.classList.remove('hide'); }
      });
    });
  }
}
customElements.define("wishlist-items", WishlistItems);